import { useAuth } from '@/services/auth';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { hasPlanFeatureEnabled } from '@/services/auth/plan-features';
import { PlanFeature } from '@/services/auth/types';
import { useConsentRecordsEnabled } from '@/services/auth/use-consent-records-enabled';

/**
 * Which log types this account can have, for the Activity type filter. Geofence and live
 * notification types follow the plan entitlement being enabled (Ember `geofence-condition` and
 * `live-notifications` read `planFeatures[...].enabled`), not a quota: a premium plan whose
 * `gated_features` omit them has none.
 */
export function useActivityTypeAvailability() {
  const { account } = useAuth();
  return {
    isGeofenceAvailable: account != null && hasPlanFeatureEnabled(account, PlanFeature.Geofences),
    isLiveNotificationsAvailable: account != null && hasPlanFeatureEnabled(account, PlanFeature.LiveNotifications),
    isConsentAvailable: useConsentRecordsEnabled(),
    isQueryObjectsAvailable: useFeatureFlag(AccountFeatureFlag.QueryObjectsAction),
    isExperimentsAvailable: useFeatureFlag(AccountFeatureFlag.ExperimentAction),
  };
}
